// Bank accounts shown on printed vouchers/invoices for payment. Add more
// entries here as they're provided -- each renders with its own QR code.
export const BANK_ACCOUNTS = [
  {
    bankName: 'MCB (Muslim Commercial Bank)',
    accountTitle: 'Muhammad Mubashir',
    accountNumber: '0767898941002377',
    iban: 'PK24MUCB0767898941002377'
  }
]
